<template>
	<h2>Finalizing Authenticatioin</h2>	
</template>

<script>
export default {
	name: 'AuthFinalize'
}
</script>
